import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=31d8063a&scoped=true&"
import script from "./Leaderboard.vue?vue&type=script&lang=js&"
export * from "./Leaderboard.vue?vue&type=script&lang=js&"
import style0 from "./Leaderboard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Leaderboard.vue?vue&type=style&index=1&id=31d8063a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d8063a",
  null
  
)

export default component.exports